import { type ReactNode } from 'react';
import { Heading, Paragraph } from '@hungryroot/ramen';

import styles from './TasteAndNeedsCard.module.css';

export const tastesAndNeedsCta = styles['quiz-button'];

interface Props {
  image: ReactNode;
  header: {
    text: string;
    icon: ReactNode;
  };
  body: ReactNode;
  recipesSummary?: {
    text: string;
    illustration: ReactNode;
    caption: string;
  };
  resumeQuizButton: ReactNode;
  queryParam?: string;
}

export function TasteAndNeedsCard(props: Props) {
  const {
    image,
    body,
    header: { text: headerText, icon },
    recipesSummary,
    resumeQuizButton,
  } = props;
  const {
    text: summaryText,
    illustration: summaryIllustration,
    caption: summaryCaption,
  } = recipesSummary || {};

  const cta = resumeQuizButton;

  return (
    <div className={styles.container}>
      <figure className={styles.figure}>
        <div className={styles.image}>{image}</div>
        <figcaption className={styles.figcaption}>
          <Heading className={styles.header} variant="H2">
            {icon} {headerText}
          </Heading>
          {body}
          {summaryText && summaryCaption && summaryIllustration && (
            <section className={styles.summary}>
              <div className={styles['summary-img']}>{summaryIllustration}</div>
              <div>
                <Heading className={styles['summary-header']} variant="H3">
                  {summaryText}
                </Heading>
                <Paragraph variant="body">{summaryCaption}</Paragraph>
              </div>
            </section>
          )}
          <div className={styles.button}>{cta}</div>
        </figcaption>
      </figure>
    </div>
  );
}
